var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuyers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "buyers_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 5h14v14H5z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#buyers_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.542 14.625-.006-.006a4.08 4.08 0 0 1 6.848-3.004.3.3 0 0 0 .199.076h1.114a.296.296 0 0 0 .291-.292.3.3 0 0 0-.093-.216l-6.312-5.967-.005-.006a.87.87 0 0 0-1.202 0l-6.312 5.962v-.006a.282.282 0 0 0 .193.496h1.166-.005a.287.287 0 0 1 .291.286v5.833c0 .32.257.577.584.577h5.191c.07-.006.134-.064.134-.14a.17.17 0 0 0-.07-.123 4.08 4.08 0 0 1-2.053-3.54z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.785 17.755 17.5 16.472a.285.285 0 0 1-.052-.344v-.006c.245-.467.379-.98.379-1.505a3.21 3.21 0 0 0-3.208-3.208 3.207 3.207 0 0 0-3.209 3.208 3.21 3.21 0 0 0 3.209 3.208 3.24 3.24 0 0 0 1.505-.385h-.006a.29.29 0 0 1 .344.046l1.283 1.284a.727.727 0 0 0 1.027-.024.74.74 0 0 0 0-1.015zm-6.207-3.13a2.036 2.036 0 0 1 2.036-2.047c1.126-.006 2.041.91 2.041 2.035s-.916 2.042-2.041 2.042a2.045 2.045 0 0 1-2.048-2.042v-.006z"
}))));
export default SvgBuyers;